export default "__VITE_ASSET__35affd4f__"